<template lang="pug">
div
  v-data-table(
    :headers="headers"
    :items="data"
    :items-per-page="10"
  )
    template(v-slot:item.tableNo="{ item }")
      span(v-if="item !== editingItem") {{ item.tableNo }}
      input(
        class="edit-component"
        v-if="item === editingItem"
        v-model="editingItem.tableNo")
    template(v-slot:item.groupId="{ item }")
      span(v-if="item !== editingItem") {{ groupName(item.groupId) }}
      editGroup(v-if="item === editingItem" :value="item.groupId" @groupId="handleUpdateGroupId")
    template(v-slot:item.name="{ item }")
      span(v-if="item !== editingItem") {{ item.name }}
      input(
        class="edit-component"
        v-if="item === editingItem"
        v-model="editingItem.name")
    template(v-slot:item.gender="{ item }")
      span(v-if="item !== editingItem") {{ item.gender }}
      select(
        class="edit-component"
        v-if="item === editingItem"
        v-model="editingItem.gender")
        option(value="男") 男
        option(value="女") 女
    template(v-slot:item.memo="{ item }")
      span(v-if="item !== editingItem") {{ item.memo }}
      input(
        class="edit-component"
        v-if="item === editingItem"
        v-model="editingItem.memo")
    template(v-slot:item.isPay="{ item }")
      v-checkbox(
        v-model="item.isPay"
        :true-value="1"
        :disabled="item !== editingItem"
        hide-details
        class="checkbox"
        label="繳費")  
    template(v-slot:item.signInStatus="{ item }")
      v-checkbox(
        v-model="item.signInStatus"
        :true-value="1"
        :disabled="item !== editingItem"
        hide-details
        class="checkbox"
        label="簽到")  
    template(v-slot:item.actions="{ item }")
      v-btn(
        v-if="item === editingItem"
        @click="updateItem(item)"
        small
        dark
        color="cyan darken-4"
        class="mx-1 text-button") 儲存
      v-btn(
        v-if="item === editingItem"
        @click="cancelEditItem(item)"
        small
        dark
        color="yellow darken-4"
        class="mx-1 text-button") 取消
      v-btn(
        v-if="item !== editingItem && !editingItem.registrationId"
        @click="editItem(item)"
        small
        outlined
        color="teal"
        class="mx-1 text-button") 編輯
      v-btn(
        v-if="item !== editingItem && !editingItem.registrationId"
        @click="handleDeleteItem(item)"
        small
        outlined
        color="red"
        class="mx-1 text-button") 刪除
  v-dialog(
    v-model="dialog"
    max-width="290")
    v-card
      v-card-title 確定要刪除 {{ deleteItem.name }} 的報名資料 ?
      v-card-actions
        v-btn(
          color="green darken-1"
          text
          @click="handleCancelDelete"
        ) 取消
        v-btn(
          color="red darken-1"
          text
          @click="handleConfirmDelete"
        ) 確定
</template>
<script>
import editGroup from '@/components/common/editGroup';
export default {
  name: "registrationSearchTable",
  props: {
    data: {
      type: Array
    },
  },
  components: {
    editGroup
  },
  data () {
    return {
      headers: [
        { text: '桌號', align: 'center', sortable: false, value: 'tableNo', width: 70 },
        { text: '序號', align: 'center', sortable: false, value: 'sortNo', },
        { text: '報名時間', align: 'center', sortable: false, value: 'registrationTime', },
        { text: '小組', align: 'center', sortable: false, value: 'groupId' },
        { text: '學員姓名', align: 'center', sortable: false, value: 'name', },
        { text: '性別', align: 'center', sortable: false, value: 'gender', },
        { text: '問題與備註', align: 'center', sortable: false, value: 'memo', },
        { text: '是否繳費', align: 'center', sortable: false, value: 'isPay', },
        { text: '是否簽到', align: 'center', sortable: false, value: 'signInStatus', },
        { text: '', align: 'center', value: 'actions', sortable: false }
      ],
      editingItem: {},
      deleteItem: {},
      dialog: false
    }
  },
  computed: {
    groups () {
      return this.$store.state.group.group
    },
  },
  methods: {
    handleUpdateGroupId (val) {
      this.editingItem['groupId'] = val
    },
    groupName (val) {
      const group = this.groups.find((item) => {return item.groupId === val})
      if (group) {
        return group.groupName
      } else {
        return '-'
      }
    },
    editItem (item) { 
      this.editingItem = item
    },
    cancelEditItem () {
      this.editingItem = {}
    },
    updateItem () {
      this.editingItem['id'] = this.editingItem.registrationId
      this.editingItem['isPay'] = this.editingItem.isPay || this.editingItem.isPay === 1 ? 1 : 0
      this.editingItem['signInStatus'] = this.editingItem.signInStatus || this.editingItem.signInStatus === 1 ? 1 : 0
      this.$emit('update', this.editingItem)
      this.editingItem = {}
    },
    handleDeleteItem (item) { 
      this.deleteItem = item
      this.dialog = true 
    },   
    handleCancelDelete () {
      this.dialog = false
      this.deleteItem = {}
    },
    handleConfirmDelete() {
      this.dialog = false
      this.$emit('delete', this.deleteItem)
      this.deleteItem = {}
    }
  }
}
</script>
<style scoped>
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td  {
  padding: 0 8px;
}
.edit-component {
  border: 1px solid #5e6e7d;
  border-radius: 4px;
  padding: 4px 8px;
  max-width: 80px;
}
.checkbox {
  width: fit-content;
  margin: 0 auto;
}
</style>